import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';

import {
	doReq
}
from 'voUtils/RestEx.js';
import {
	findResultFields
}
from 'voUtils/BrowserEx.js';

export default {

	data() {
			return {
				units: [],
				show: false
			};
		},

		beforeMount() {

			const results = this.$el.getElementsByClassName('unit-list-section');
			if (results.length) {
				this.resultFields = findResultFields(results[0].innerHTML, this.$el);
			}

			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
			const savedUnits = JSON.parse(localStorage.getItem('lastVisitedUnits_' + suffix));

			if (savedUnits && Object.keys(savedUnits).length > 0) {

				this.show = true;

				let unitsIds = [];
				for (let index = 0; index < Object.keys(savedUnits).length; index++) {
					unitsIds.push(savedUnits[index]._id);
				}

				const req = {
					fields: this.resultFields,
					filter: {},
					ids: unitsIds
				};

				doReq('searchUnits', req)
					.then((res) => {

						this.units = res.units;

						// Wait for DOM update
						this.$nextTick(() => {

							this.initSlider();

							$(this.$el).find('[data-toggle="tooltip"]').tooltip();
							$(this.$el).find('[data-toggle="popover"]').popover();

						});
					});
			}
		},

		methods: {

			show() {
					return this.units.length > 0;
				},

				getUnitSearchTarget(id) {
					return 'unit_' + id;
				},

				initSlider() {

					const $carousel = $(this.$el).find(".owl-carousel.lastviewed-units");
					if (!$carousel.length) return;

					// Prevent re-initialization
					if ($carousel.hasClass('owl-loaded')) return;

					const $wrapper = $carousel.closest(".carousel-wrapper");

					$carousel.owlCarousel({
						loop: false,
						margin: VOFFICE.settings.olwCarouselMargin,
						smartSpeed: 1000,
						autoplay: false,
						nav: VOFFICE.settings.olwCarouselNav,
						dots: true,
						responsive: {
							0: {
								items: 1
							},
							768: {
								items: 2
							},
							996: {
								items: 3
							},
							1200: {
								items: 3
							}
						}
					});


					$carousel.on('initialized.owl.carousel changed.owl.carousel', function () {
						setTimeout(() => {
							updateDots();
							updateTabindex();
						}, 50);
					});

					function updateDots() {
						$carousel.find('.owl-dot').each(function (index) {
							$(this)
								.attr('aria-label', 'Gehe zu Slide ' + (index + 1))
								.find('span')
								.html('<span class="sr-only">Gehe zu Slide ' + (index + 1) + '</span>');
						});
					}

					function updateTabindex() {
						$carousel.find(".owl-item").each(function () {

							const $item = $(this);

							$item.find('a, button, input, select, textarea, [tabindex]').each(function () {

								if (!$item.hasClass("active")) {
									$(this).attr("tabindex", "-1");
								} else {
									if ($(this).attr("tabindex") === "-1" && !$(this).hasClass("notremovetabindex")) {
										$(this).removeAttr("tabindex");
									}
								}

							});
						});
					}


					const that = this;
					const $navButtons = $carousel.find(".owl-prev, .owl-next");

					$navButtons.attr({
						tabindex: "0",
						"aria-label": function () {
							return $(this).hasClass('owl-prev') ? that.voMsg('tpl.text.prevSlide') : that.voMsg('tpl.text.nextSlide');
						}
					});


					$wrapper
						.attr("tabindex", "0")
						.off("keydown.owlNav")
						.on("keydown.owlNav", function (e) {

							if (e.key === "ArrowLeft") {
								$carousel.trigger("prev.owl.carousel");
								e.preventDefault();
							}

							if (e.key === "ArrowRight") {
								$carousel.trigger("next.owl.carousel");
								e.preventDefault();
							}

						});
				}
		}
};